/*
 * @Author: your title
 * @Date: 2020-12-25 15:24:07
 * @LastEditTime: 2022-03-03 11:16:18
 * @LastEditors: DG
 * @Description:
 * 重构项目的route & menu 机制
 * 实现：
 * 1.路由的自动加载
 * 2.配置文件与umi靠齐，为迁移做准备
 * @FilePath     : /fe-ts-basic-platform/src/routers/index.js
 */
import { SALARY_CALC_MODE } from '@/utils/const';

/*
   ptp_routes-微应用对应的路由映射，目前需要手动维护
 */
const ptp_routes = [
  {
    title: '打卡界面',
    icon: 'idcard',
    path: '/assist',
    component: 'pages/micro',
    openNewTab: true,
  },
  {
    title: '数据明细表',
    icon: 'profile',
    path: '/schedule',
    component: 'layouts',
    routes: [
      {
        title: '作业打卡表',
        path: '/schedule/taskList',
        component: 'pages/micro',
        access: 'schedule.task.list.view',
      },
      {
        title: '配置打卡表',
        path: '/schedule/configPunch',
        component: 'pages/micro',
        access: 'schedule.config.list.view',
      },
      {
        title: '打卡汇总表',
        path: '/schedule/punchSummary',
        component: 'pages/micro',
        access: 'schedule.punchSummary.list.view',
      },
      {
        title: '作业单据表',
        path: '/schedule/jobList',
        component: 'pages/micro',
        access: 'schedule.job.list.view',
      },
      {
        title: '上下工打卡明细表',
        path: '/schedule/onOffWork',
        component: 'pages/micro',
        access: false,
      },
      {
        title: '作业单详情',
        path: '/schedule/jobDetail',
        component: 'pages/micro',
        hideInMenu: true,
      },
      {
        title: '考勤明细表',
        path: '/schedule/attend',
        component: 'pages/micro',
        access: 'schedule.attendance.list.view',
      },
    ],
  },
  {
    title: '数据报表',
    icon: 'table',
    component: 'layouts',
    path: '/report',
    routes: [
      {
        title: '用工数据日报表',
        path: '/report/workDailyReport',
        component: 'pages/micro',
        access: false,
      },
      {
        title: '个人工时劳效表',
        path: '/report/personalWorkReport',
        component: 'pages/micro',
        access: false,
      },
      {
        title: '薪资日报表',
        path: '/report/salaryList',
        component: 'pages/micro',
        access: 'report.salary.list.view',
      },
      {
        title: '薪资月报表',
        path: '/report/monthSalaryList',
        component: 'pages/micro',
        access: 'report.monthSalary.list.view',
      },
      {
        title: '仓库人效看板',
        path: '/report/effectKanban',
        component: 'pages/micro',
        access: 'report.effectkanban.view',
      },
      {
        title: '仓库人效明细',
        path: '/report/effectDetail',
        component: 'pages/micro',
        access: 'report.effectdetail.view',
      },
    ],
  },
];

const routes = [
  {
    title: '首页',
    icon: 'home',
    path: '/',
    component: 'pages/home',
  },
  {
    title: '账号管理',
    path: '/auth',
    icon: 'user',
    component: 'layouts',
    routes: [
      {
        title: '账号管理',
        path: '/auth/account',
        component: 'pages/auth/account',
        access: 'auth.account.view',
      },
      {
        title: '权限集管理',
        path: '/auth/role',
        component: 'pages/auth/power',
        access: 'auth.role.view',
      },
      {
        title: '权限点管理',
        path: '/auth/point',
        component: 'pages/auth/point',
        access: 'auth.point.view',
      },
    ],
  },
  {
    title: '主数据管理',
    icon: 'database',
    path: '/main',
    component: 'layouts/index',
    routes: [
      {
        title: '货主管理',
        path: '/main/customer',
        component: 'pages/main/customer',
        access: 'main.customer.view',
      },
      {
        title: '仓库管理',
        path: '/main/station',
        component: 'pages/main/station',
        access: 'main.station.view',
      },
      {
        title: '计薪参数管理',
        path: '/main/salaryParameter',
        component: 'pages/main/salaryParameter',
        access: 'main.salaryparam.view',
      },
    ],
  },
  {
    title: '仓库业务管理',
    icon: 'project',
    component: 'layouts',
    path: '/site',
    routes: [
      {
        title: '仓库信息管理',
        path: '/site/stationInfo',
        component: 'pages/site/stationInfo',
        access: 'site.stationinfo.view',
      },
      {
        title: '任务类型管理',
        path: '/site/content',
        component: 'pages/site/content',
        access: 'site.content.view',
      },
      {
        title: '计薪方案配置',
        path: '/site/payrollManage',
        component: 'pages/site/payrollManage',
        access: 'site.plan.view',
      },
      {
        title: '计薪方案调整',
        path: '/site/salaryScheme',
        component: 'pages/site/salaryScheme',
        hideInMenu: true,
        access: 'site.plan.create',
      },
      // {
      //   title: '计薪方案调整',
      //   path: '/site/payrollPlan',
      //   component: 'pages/site/payrollPlan',
      //   hideInMenu: true,
      //   access: 'site.plan.create',
      // },
      {
        title: '汇率管理',
        path: '/site/rate',
        component: 'pages/site/rate',
        access: 'site.rate.view',
        conditions: {
          paidModel: SALARY_CALC_MODE.DEFINE.MAN_HOUR_MODE,
        },
      },
      {
        title: '货主组管理',
        path: '/site/shipperGroupManagement',
        component: 'pages/site/shipperGroupManagement',
        access: 'site.customergroup.view',
      },
      {
        title: '产品档案管理',
        path: '/site/skuManagement',
        component: 'pages/site/skuManagement',
        access: 'site.sku.view',
      },
      {
        title: '计件编组管理',
        path: '/site/pieceGroupManagement',
        component: 'pages/site/pieceGroupManagement',
        access: 'site.piecegroup.view',
      },
      {
        title: '编组类型管理',
        path: '/site/groupTypeManagement',
        component: 'pages/site/groupTypeManagement',
        access: 'site.grouptype.view',
      },
      {
        title: '设备地址管理',
        path: '/site/deviceManagement',
        component: 'pages/site/deviceManagement',
        access: 'site.stationmac.view',
      },
      {
        title: '员工计薪配置',
        path: '/site/staffSalary',
        component: 'pages/site/staffSalary',
        access: 'site.staffsalary.view',
        conditions: {
          paidModel: SALARY_CALC_MODE.DEFINE.MAN_HOUR_MODE,
        },
      },
      {
        title: '基础配置',
        path: '/site/basicSetting',
        component: 'pages/site/basicSetting',
        access: 'site.basicSetting.view',
      },
    ],
  },
  ...ptp_routes,
];

export default routes;
